import { SERVER } from "../constants";
import { MAP_URL } from "../constants/urls";
import { HttpClient } from "../utils/requests";

import { adminUserMapperGetOneResponse } from "../panels/adminUsers/adminUsersMapper";
import { insertPaybillMapperGetOneResponse } from "../panels/hr/insertPaybill/insertPaybillMapper";
import { paybillsMapperGetOneResponse } from "../panels/hr/paybills/paybillsMapper";
import { requestsMapperGetOneResponse } from "../panels/hr/requests/requestsMapper";

export function getOne(resource, params) {
  return HttpClient(`${SERVER}/${MAP_URL[resource]}/${params.id}`).then(({ json }) => {
    if (resource === 'insertPaybill') {
      return insertPaybillMapperGetOneResponse(json);
    } else if (resource === 'paybills') {
      return paybillsMapperGetOneResponse(json);
    } else if (resource === 'request') {
      return requestsMapperGetOneResponse(json);
    } else if (resource === 'adminUsers') {
      return adminUserMapperGetOneResponse(json);




    }
    return {
      data: { ...json.result, id: json.result.phoneNumber },
    };
  }
  );
}
